import { render, staticRenderFns } from "./PrimalPlungeCaseStudy.vue?vue&type=template&id=338a13f4&scoped=true"
import script from "./PrimalPlungeCaseStudy.vue?vue&type=script&lang=js"
export * from "./PrimalPlungeCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./PrimalPlungeCaseStudy.vue?vue&type=style&index=0&id=338a13f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a13f4",
  null
  
)

export default component.exports